import Vue from "vue";
import Component from "vue-class-component";
import SidebarComponent from "@/components/sidebar/sidebar.component.vue";
import HeaderComponent from "@/components/header/header.component.vue";
import LoaderComponent from "@/components/loader/loader.component.vue";
import ModalPermissionsComponent from "@/components/modal-permissions/modal-permissions.component.vue";
import ModalLoginComponent from "@/components/modal-login/modal-login.component.vue";
// External components
import Datepicker from "vuejs-datepicker";
// Services
import CandidateService from "@/core/services/candidate.service";
import SidebarService from "@/core/services/sidebar.service";

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    Datepicker,
  },
})
export default class EvaluatedComponent extends Vue {
  // Service's Instance
  candidateService: any = new CandidateService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  modal: boolean = false;
  showModal: boolean = false;
  deleteIcon: boolean = false;
  nextPositionDisabled: boolean = false;
  previousPositionDisabled: boolean = true;
  pagination: boolean = true;
  userToDelete: any;
  searchFlag: any = [];
  searchFlagYear: any = [];
  candidateList: any = [];
  filterCandidateList: any = [];
  companyList: any = [];
  name: string = "";
  search: string = "";
  searchYear: string = "";
  companies: string = "";
  surveys: string = "";
  finderCompanies: string = "default";
  searchByDate: any = "";
  createdAt: string = "";
  progress: string = "";
  filterConcatDate: string = "";
  companyToSearch: string = "";
  pageOffset: number = 0;
  itemsPerPage: number = 1000000;
  totalPages: number = 0;
  currentPage: number = 1;
  nextPage: number = 2;
  totalOfEvaluated: number = 0;
  itemsOfFrom: number = 0;
  itemsOfTo: number = 0;
  isTrainingSuperAdmin: boolean = false;
  filterBySurvey: number = 0;
  searchBySurveyFlag: boolean = false;
  evaluationsEnd: Array<any> = [];
  totalEvaluations: number = 0;
  public endDate: any = "";
  public startDate: any = "";
  public reporterZoneId: any;
  public evaluatedCompletedCount = [];
  public reportersName = {
    2: "Centro",
    3: "Norte",
    4: "Occidente",
    5: "Noroeste",
  };

  // Reports variables
  public selectedCompanyCandidatesEndedUp: string = "";
  public reportStartDate: string = "";
  public reportEndDate: string = "";
  public reportType: "finished" | "created";
  public monthlyReportError: boolean = false;
  public showReportModal: boolean = false;
  public reportRegion: string = "all";

  mounted() {
    const _ = this;
    _.isTrainingAdmin();
    _.get();
  }

  deleteDate() {
    const _ = this;
    _.filterConcatDate = "";
    _.deleteIcon = false;
    if (_.filterConcatDate == "") {
      _.searchByDate = "";
      _.filterCandidateList = _.candidateList;
      return;
    }
  }

  filterDate(date: any = "") {
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  saveSurveyPercentages(surveys: any) {
    const _ = this;
    sessionStorage.setItem("personalStylePercentage", surveys[0].progress);
    sessionStorage.setItem("communicationStylePercentage", surveys[1].progress);
    sessionStorage.setItem("mapPercentage", surveys[2].progress);
  }

  filterByDate(startDate, endDate) {
    const hasStartDate = Boolean(startDate);
    const hasEndDate = Boolean(endDate);

    if ((hasStartDate && !hasEndDate) || (!hasStartDate && hasEndDate)) {
      return;
    }
    const formattedStartDate = new Date(startDate)
      .toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "2-digit",
      })
      .replace(/\//g, "-");

    const formattedEndDate = new Date(endDate)
      .toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "2-digit",
      })
      .replace(/\//g, "-");

    this.get(formattedStartDate, formattedEndDate, this.reporterZoneId);
  }

  formattedDates(date) {
    const dateObject = new Date(date); // Creating a Date object from the startDate string
    const formattedDate = dateObject.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });

    return formattedDate;
  }

  get(startDate = null, endDate = null, reportedId = null) {
    this.isLoading = true;
    if (startDate && endDate) {
      startDate = this.formattedDates(startDate);
      endDate = this.formattedDates(endDate);
    }

    this.candidateService
      .get(startDate, endDate, reportedId)
      .then(({ data }) => {
        const { candidates, total } = data;
        this.totalEvaluations = candidates.length;
        this.candidateList = candidates;
        this.filterCandidateList = candidates;
        this.totalOfEvaluated = total;
        this.getEvaluationsEnd(data.candidates);
        setTimeout(() => {
          this.isLoading = false;
        }, 2000);
      })
      .catch((err) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 2000);
      });
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  delete_user() {
    const _ = this;
    _.isLoading = true;
    _.candidateService
      .delete_user(_.userToDelete)
      .then((data: any) => {
        _.get();
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      });
  }

  nextPageAction() {
    const _ = this;
    _.itemsOfTo = _.itemsOfTo + _.candidateList.length;
    _.itemsOfFrom = _.itemsOfFrom + _.candidateList.length;
    _.pageOffset++;
    _.currentPage++;
    _.nextPage++;
    _.get(_.pageOffset);

    if (_.totalPages == _.currentPage) {
      _.nextPositionDisabled = true;
      return;
    }
  }

  previousPageAction() {
    const _ = this;
    if (_.currentPage == 1) {
      return;
    }
    _.itemsOfTo = _.itemsOfTo - _.candidateList.length;
    _.itemsOfFrom = _.itemsOfFrom - _.candidateList.length;
    _.pageOffset--;
    _.currentPage--;
    _.nextPage--;
    _.get(_.pageOffset);

    if (_.totalPages != _.currentPage) {
      _.nextPositionDisabled = false;
      return;
    }
  }

  private isTrainingAdmin() {
    const _ = this;
    const companyId = localStorage.getItem("company");
    if (companyId === "null" || companyId === "1") {
      _.isTrainingSuperAdmin = true;
    }
  }

  public percentageByEvaluated(user, userId: number) {
    const surveyProgresses = {};
    const surveys =
      user && user.batches.length > 0 ? user.batches[0].surveys : [];
    const isUsingEndDates = this.endDate !== "" && this.startDate !== "";

    if (surveys && surveys.length) {
      surveys.forEach((survey) => {
        surveyProgresses[survey.surveyId] = survey.surveyProgress;
      });

      const surveyOneReal = (surveyProgresses[1] || 0) * 0.1;
      const surveyTwoReal = (surveyProgresses[2] || 0) * 0.1;
      const surveyThreeReal = (surveyProgresses[3] || 0) * 0.8;

      const result = surveyOneReal + surveyTwoReal + surveyThreeReal;

      const progress = Math.round(result);

      let evaluations = 0;
      if (progress === 100 && !this.evaluatedCompletedCount.includes(userId)) {
        evaluations = 1;
        this.evaluatedCompletedCount.push(userId);
      }

      if (isUsingEndDates) {
        return 100;
      }

      return progress;
    }
  }

  public getEvaluationsEnd(data: Array<any>) {
    for (let i = 0; i < data.length; i++) {
      const isSurveyComplete =
        data[i].batches.length > 0
          ? data[i].batches[0].surveys[2].progress === 100
          : false;
      if (isSurveyComplete) {
        this.evaluationsEnd.push(isSurveyComplete);
      }
    }
  }

  public downloadMonthlyReport() {
    this.showReportModal = true;
  }

  public downloadReport() {
    this.isLoading = true;
    this.monthlyReportError = false;

    const companyId = 1;
    const startDate = this.reportStartDate;
    const endDate = this.reportEndDate;
    const reportType = this.reportType || "finished";

    let region = "all";
    if (this.reportRegion !== "all") {
      region = this.reportRegion;
    }

    this.candidateService
      .downloadMonthlyReport(companyId, startDate, endDate, reportType, region)
      .then((response) => {
        this.isLoading = false;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "reporte_mensual.xlsx");
        document.body.appendChild(link);
        link.click();
        this.showReportModal = false;
      })
      .catch((error) => {
        this.isLoading = false;
        this.monthlyReportError = true;
        console.log(error);
      });
  }
}
